import swal from "sweetalert";
import axiosInstance from "../api";
import { setGetSingleMembership, setGetmemberShipList } from "../reusable/reusableSlice";


export const getMembershipList = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post("membership/get_all",data);
      if (response?.data) {
        dispatch(setGetmemberShipList(response?.data?.response))
      } else {
        dispatch(setGetmemberShipList([]))
      } 
      return response
    } catch (err) {
      console.error(err);
      dispatch(setGetmemberShipList([]))
    }
  };

  export const addMembership = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("membership/create", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/membership")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  export const getSingleMebershipId = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(`membership/get_byid/${id}`);
      if (response?.data) {
        dispatch(setGetSingleMembership(response?.data?.response))
      } else {
        dispatch(setGetSingleMembership([]))
      }
    } catch (err) {
      console.error(err);
      dispatch(setGetSingleMembership([]))
    }
  };

  export const updateMembership = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("membership/update", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/membership")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  export const deleteOneMembership = (id) => async (dispatch) => {
    try {
      const response = await axiosInstance.delete(`membership/delete/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        return response
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    }
  };